import { useState } from "react";
import { api, fmtDate } from "../api";
import { useLang, useT } from "../i18n";
import { Head, Modal, useApi, useShell } from "../ui";

interface Perk { id: string; kind: string; code: string; state: string; wonAt: string; givenToName?: string; reservedOnQuoteId?: string }
const NAMES: Record<string, string> = { upgrade_request: "Room upgrade request", package_discount_50: "$50 off a client package", free_transfer: "Free airport transfer" };
const STATE: Record<string, string> = { available: "Available", reserved: "On a quote", used: "Used", given: "Given" };

/** The perks wallet (docs/37 S7): won in the Lounge, used on a quote or given to a client. */
export function Perks() {
  const t = useT();
  const lang = useLang();
  const { openLounge, toast } = useShell();
  const { data, reload } = useApi<{ perks: Perk[] }>("/perks");
  const [giving, setGiving] = useState<Perk | null>(null);
  const [name, setName] = useState("");
  const perks = data?.perks ?? [];
  const lockedKinds = Object.keys(NAMES).filter((k) => !perks.some((p) => p.kind === k));
  return (
    <>
      <Head eyebrow={t("perks.eyebrow")} title={t("nav.perks")} extra={<button className="btn ink" type="button" onClick={() => openLounge()}>{t("perks.play")}</button>} />
      <p className="muted" style={{ maxWidth: "70ch" }}>{t("perks.text")}</p>
      <div className="wallet" data-testid="wallet">
        {perks.map((p) => (
          <div key={p.id} className="perk-card"><small>Won {fmtDate(p.wonAt, lang)} · {STATE[p.state]}{p.givenToName ? ` · ${p.givenToName}` : ""}</small><b>{NAMES[p.kind]}</b><code>{p.code}</code>
            {p.state === "available" ? <button className="btn line sm" type="button" onClick={() => setGiving(p)}>{t("perks.give")}</button> : null}</div>
        ))}
        {lockedKinds.map((k) => <div key={k} className="perk-card locked"><small>Locked</small><b>{NAMES[k]}</b><code>{t("perks.locked")}</code></div>)}
      </div>
      {giving ? (
        <Modal title={t("perks.give")} onClose={() => setGiving(null)}>
          <form className="mform" onSubmit={(e) => { e.preventDefault(); api(`/perks/${giving.id}/give`, { body: { name } }).then(() => { setGiving(null); reload(); toast(`${NAMES[giving.kind]} given to ${name}.`); }, (x: Error) => toast(x.message)); }}>
            <p className="muted">{NAMES[giving.kind]} · {giving.code}. Your client sees it on their proposal page.</p>
            <label className="f">Client name<input required value={name} onChange={(e) => setName(e.target.value)} /></label>
            <div className="q-actions"><button className="btn line" type="button" onClick={() => setGiving(null)}>{t("common.cancel")}</button><button className="btn ink" type="submit">{t("perks.give")}</button></div>
          </form>
        </Modal>
      ) : null}
    </>
  );
}
